import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createErrorResult, createExceptionResult, createSuccessResult } from './common/utils/resultful';
export { isSuccessful, isFailure, isError, isException } from './common/utils/resultful';

/**
 * A set of GET/POST/etc HTTP helpers that can generally be applied to all APIs in HAMS
 */

/**
 * Wrapper around the normal fetch client for GET calls to HAMS.
 */
export var get = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetch, url) {
    var options,
      response,
      json,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          _context.prev = 1;
          _context.next = 4;
          return fetch(url, _objectSpread(_objectSpread({}, options), {}, {
            headers: _objectSpread({
              Accept: 'application/json'
            }, options.headers),
            method: 'GET'
          }));
        case 4:
          response = _context.sent;
          if (!(response.status === 204)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", createSuccessResult(null));
        case 7:
          _context.next = 9;
          return response.json();
        case 9:
          json = _context.sent;
          if (!response.ok) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return", createSuccessResult(_objectSpread(_objectSpread({}, json), {}, {
            status: response.status
          })));
        case 14:
          return _context.abrupt("return", createErrorResult(json));
        case 15:
          _context.next = 20;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", createExceptionResult(_context.t0));
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 17]]);
  }));
  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();